import { render, staticRenderFns } from "./DrawingCanvasBlank.vue?vue&type=template&id=3da71260&scoped=true&"
import script from "./DrawingCanvasBlank.vue?vue&type=script&lang=ts&"
export * from "./DrawingCanvasBlank.vue?vue&type=script&lang=ts&"
import style0 from "./DrawingCanvasBlank.vue?vue&type=style&index=0&id=3da71260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da71260",
  null
  
)

export default component.exports